 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {
  Add,
  ArrowBack,
  AutoAwesome,
  CreditScore,
  ExitToApp,
  Forum,
  Group,
  Groups,
  Key,
  PlaylistAddCheck,
  Timeline,
  Warning,
  WorkOutline
} from '@mui/icons-material'
import React from 'react'
import {useHistory, useRouteMatch} from 'react-router'
import PlainButton from '~/components/PlainButton/PlainButton'
import {PALETTE} from '~/styles/paletteV3'
import {Breakpoint, NavSidebar} from '~/types/constEnums'
import makeMinWidthMediaQuery from '~/utils/makeMinWidthMediaQuery'

const NavItem = styled(PlainButton)(({isActive}) => ({
  alignItems: 'center',
  backgroundColor: isActive ? PALETTE.SLATE_300 : undefined,
  borderRadius: 4,
  color: PALETTE.SLATE_700,
  display: 'flex',
  fontSize: NavSidebar.FONT_SIZE,
  fontWeight: 600,
  lineHeight: NavSidebar.LINE_HEIGHT,
  marginBottom: 8,
  marginTop: 8,
  padding: 8,
  textDecoration: 'none',
  transition: `background-color 100ms ease-in`,
  userSelect: 'none',
  width: '100%',
  [makeMinWidthMediaQuery(Breakpoint.SIDEBAR_LEFT)]: {
    borderRadius: '0 4px 4px 0'
  },
  ':hover': {
    backgroundColor: PALETTE.SLATE_300
  }
}))

const StyledIcon = styled('div')({
  height: 24,
  width: 24,
  color: PALETTE.SLATE_700,
  marginRight: 16,
  opacity: 0.5
})

const Label = styled('div')({
  flex: 1,
  wordBreak: 'break-word'
})

const iconLookup = {
  magic: React.createElement(AutoAwesome, null ),
  arrowBack: React.createElement(ArrowBack, null ),
  creditScore: React.createElement(CreditScore, null ),
  forum: React.createElement(Forum, null ),
  playlist_add_check: React.createElement(PlaylistAddCheck, null ),
  add: React.createElement(Add, null ),
  exit_to_app: React.createElement(ExitToApp, null ),
  group: React.createElement(Group, null ),
  groups: React.createElement(Groups, null ),
  warning: React.createElement(Warning, null ),
  work: React.createElement(WorkOutline, null ),
  timeline: React.createElement(Timeline, null ),
  key: React.createElement(Key, null )
}












const LeftDashNavItem = (props) => {
  const {className, label, icon, href, navState, onClick} = props
  const history = useHistory()
  const match = useRouteMatch(href)
  const handleClick = () => {
    history.push(href, navState)
    _optionalChain([onClick, 'optionalCall', _ => _()])
  }
  return (
    React.createElement(NavItem, {
      className: className,
      onClick: handleClick,
      isActive: !!match && (_optionalChain([match, 'optionalAccess', _2 => _2.isExact]) || !props.exact),}

      , React.createElement(StyledIcon, null, iconLookup[icon])
      , React.createElement(Label, null, label)
    )
  )
}

export default LeftDashNavItem
